



























































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import AuthorizationDeleteModal from "@/components/authorizations/modals/AuthorizationDeleteModal.vue";
import AuthorizationInfoModal from "@/components/authorizations/modals/AuthorizationInfoModal.vue";
import SelectAuthorizationFlow from "@/components/authorizations/modals/SelectAuthorizationFlow.vue";
// service methods
import { getAllAuthorizations } from "@/services/authorizations/authorizationService";
// types
import { Authorization, FlowTypesEnum } from "@/services/authorizations/types";
import { authorizationsFields } from "@/components/authorizations/fields/authorizationFields";

@Component({
    components: { AuthorizationDeleteModal, AuthorizationInfoModal, SelectAuthorizationFlow }
})
export default class Authorizations extends Vue {
    // local state
    authorizations = [] as Array<Authorization>;
    searchQuery = "";
    isBusy = false;
    fields = authorizationsFields;
    flowTypesEnum = FlowTypesEnum;

    // lifecycle hooks
    public created(): void {
        this.fetchData();
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    openSelectFlowModal() {
        (this.$refs.selectAuthorizationFlowModal as any).open();
    }

    updateAuthorization(authorization: Authorization) {
        if (authorization.flowType === FlowTypesEnum.ResourceOwnerPasswordCredentialsFlow) {
            return {
                name: "updateRopcAuthorization",
                params: { authorizationId: authorization.id }
            };
        } else if (authorization.flowType === FlowTypesEnum.AuthorizationCodeFlow) {
            return {
                name: "updateAcfAuthorization",
                params: { authorizationId: authorization.id }
            };
        } else if (authorization.flowType === FlowTypesEnum.ClientCredentialFlow) {
            return {
                name: "updateCcfAuthorization",
                params: { authorizationId: authorization.id }
            };
        }
    }

    fetchData() {
        getAllAuthorizations().then(response => {
            this.authorizations = response;
        });
    }

    get filteredData(): Array<Authorization> {
        return this.authorizations.filter(
            x =>
                this.searchQuery.length === 0 ||
                x.credentialsName.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }

    info(id: string) {
        (this.$refs.authorizationInfoModal as any).open(id);
    }

    deleteAuthorization(id: string, name: string) {
        (this.$refs.authorizationDeleteModal as any)
            .open(id, name);
    }
}
